// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LogEntries__entries___AxJWv {
    width: min(90%, 540px);
    max-width: 540px;
    margin: 0 auto;
}

.LogEntries__areEditable___LuSCT {
    background: red;
}

.LogEntries__centerText___Y_wfo {
    text-align: center;
}

.LogEntries__reduceOpacity___BWwXz {
    opacity: 0.76;
}

.LogEntries__logRow___OPLV0 {
    background: linear-gradient(
        90deg,
        var(--log-row-rail-accent-color) 0%,
        rgba(9, 17, 25, 0.75) 24%,
        rgba(10, 18, 26, 0.72) 58%,
        var(--log-row-background-color) 100%
    );
    border-radius: 5px;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.08),
        0 0 0 1px var(--log-row-border-color),
        0 8px 18px rgba(0, 0, 0, 0.18);
    color: rgb(237, 230, 212);
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    margin: 4px 0;
    overflow: hidden;
    position: relative;
    transition:
        box-shadow 500ms cubic-bezier(0.2, 0.8, 0.2, 1),
        opacity 500ms cubic-bezier(0.2, 0.8, 0.2, 1);
}

.LogEntries__logRow___OPLV0::after {
    background: linear-gradient(
        90deg,
        var(--log-row-hover-rail-accent-color) 0%,
        rgba(10, 18, 26, 0.78) 24%,
        rgba(11, 20, 28, 0.74) 58%,
        var(--log-row-hover-background-color) 100%
    );
    content: "";
    inset: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transition: opacity 500ms cubic-bezier(0.2, 0.8, 0.2, 1);
    z-index: 0;
}

.LogEntries__logRow___OPLV0:hover {
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.1),
        0 0 0 1px var(--log-row-border-color),
        0 9px 18px rgba(0, 0, 0, 0.16);
}

.LogEntries__logRow___OPLV0:hover::after {
    opacity: 1;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entries": `LogEntries__entries___AxJWv`,
	"areEditable": `LogEntries__areEditable___LuSCT`,
	"centerText": `LogEntries__centerText___Y_wfo`,
	"reduceOpacity": `LogEntries__reduceOpacity___BWwXz`,
	"logRow": `LogEntries__logRow___OPLV0`
};
module.exports = ___CSS_LOADER_EXPORT___;
